var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"interaction"},[_c('div',{staticClass:"apparel"},[_c('div',{staticClass:"center"},[_c('div',{staticClass:"exchange"},[_c('h2',[_vm._v("Smart Wearables"),_c('br'),_vm._v(" Data Collection")]),_c('p',[_vm._v("Real-time human body data collection under the"),_c('br'),_vm._v(" collaboration of wearable devices and Al algorithms.")])])])])])
}]

export { render, staticRenderFns }